import { Grid } from "@material-ui/core";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { groupBy } from "lodash";
import { useMemo } from 'react';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { theme } from "styles/theme";
import { washDashboardStyles } from "../WashDashboardStyles";
import ExportButton from "components/ExportButton/ExportButton";
import { IconDownload } from "icons";

const SlaPerLotCard = ({ vehiclesReadiness }) => {
    const classes = washDashboardStyles();
    let { data: getLots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    const lots = getLots?.filter(l => l.ownedByTenant) ?? [];

    const vehiclesReadinessGrouped = groupBy(vehiclesReadiness, 'lotId');
    const chartData = useMemo(() => {
        if (!lots) return [];
        return lots?.map(lot => {
            const readinessForLot = vehiclesReadinessGrouped?.[lot?.id] ?? [];
            const allLength = readinessForLot?.length ?? 0;
            const withinSla = readinessForLot?.length ? (readinessForLot?.filter(x => x.underSlaInLastCycle == true)?.length ?? 0) / allLength * 100 : 0;
            const aboveSla = readinessForLot?.length ? (readinessForLot?.filter(x => x.underSlaInLastCycle == false)?.length ?? 0) / allLength * 100 : 0;

            return {
                ...lot,
                withinSlaPercent: withinSla ?? 0,
                aboveSlaPercent: aboveSla ?? 0
            };
        });
    }, [lots, vehiclesReadiness]);

    const GraphTooltip = ({ val }) => {
        return (
            <div className={classes.tooltip}>
                <div><b>{val?.label}</b></div>
                <div>Within SLA: <b>{Math.round(val?.payload?.[0]?.value ?? 0)}%</b></div>
                <div>Above SLA: <b>{Math.round(val?.payload?.[1]?.value ?? 0)}%</b></div>
            </div>
        )
    }

    const mapExportData = (a => {
        return {
            ['Lot']: a.name,
            ['Within SLA']: `${a.withinSlaPercent}%`,
            ['Above SLA']: `${a.aboveSlaPercent}%`
        };
    })

    return (
        <Grid item style={{ height: 350, marginTop: '2em', position: 'relative' }}>
            <div style={{ position: 'absolute', top: '-3em', right: '0.5em' }}>
                <ExportButton
                    btnStyle='text'
                    label=""
                    icon={<IconDownload />}
                    fileLabel="Export"
                    data={chartData}
                    mapExportData={mapExportData}
                />
            </div>
            <ResponsiveContainer width="95%" height="95%">
                <BarChart
                    data={chartData}
                >
                    {/* <YAxis
                        type="number"
                        axisLine={false}
                        tickLine={false}
                    /> */}
                    <XAxis
                        type="category"
                        axisLine={false}
                        interval={~~(chartData?.length / 40)}
                        dataKey="name"
                        tickLine={false}
                        tick={{
                            color: theme.palette.primary.main,
                            fontSize: '0.8em',
                            fontWeight: '500',
                            dx: -4,
                        }}
                        angle={-90}
                        textAnchor="end"
                        height={70}
                    />
                    <Tooltip
                        content={(val) => <GraphTooltip val={val} />}
                    />

                    <Legend
                        wrapperStyle={{ bottom: -10 }}
                        iconType="circle"
                        iconSize={10}
                    />
                    <Bar dataKey="withinSlaPercent" fill="#33A6FE" name="Within SLA" />
                    <Bar dataKey="aboveSlaPercent" fill="#FFD966" name="Above SLA" />
                </BarChart>
            </ResponsiveContainer>
        </Grid>
    );
};

export default SlaPerLotCard;
